import { FC } from 'react';
import { useRecoilState } from 'recoil';
import myInfoState from '../../../atoms/myinfo';
import roomDetailState from '../../../atoms/roomDetail';
import { SystemMessageType, UserDetail } from '../../../connector/type';
import './SystemMessage.scoped.scss';
import { openAlert } from '../../../atoms/common';

interface SystemMessageProps {
  userId: string;
  userDetail: UserDetail | undefined;
  contents: {
    systemMessageType: SystemMessageType;
    receiverName?: string;
    quantity?: number;
    fullRound?: string;
    round?: number;
    pick?: string;
    ownerName?: string;
    roomId?: string;
    roomName?: string;
    isProject?: boolean;
    isSecret?: boolean;
    result?: string;
    amount?: number;
    gameType?: string;
    isWin?: 1 | 0 | -1;
    record?: {
      win: number;
      defeat: number;
    },
    count?: number;
    userId?: string;
    userName?: string;
    expiredTime?: number;
  };
}

const SystemMessage: FC<SystemMessageProps> = ({ userId, userDetail, contents }) => {
  const [myInfo] = useRecoilState(myInfoState);
  const [roomDetil] = useRecoilState(roomDetailState);

  let backgroundColor = '#ce6300';
  let preparedCode = <></>;
  let code = <></>;

  if (contents.systemMessageType === SystemMessageType.CREATE_ROOM) {
    backgroundColor = '#428bca';
    code = (
      <div>
        <b style={{ color: '#fff4d3' }}>{contents.ownerName}</b>님이&nbsp;
        { contents.isProject ? '프리미엄' : '일반' } 채팅방&nbsp;
        <b style={{ color: '#fff4d3' }}>{contents.roomName}</b>을 개설하였습니다.&nbsp;
        <button
          style={{
            color: '#fff4d3',
            padding: 0,
          }}
          onClick={() => {
            if (contents.isSecret) {
              openAlert('비밀방은 채팅 대기실을 통해 입장해주세요.');
            } else if (contents.isProject) {
              openAlert('프리미엄방은 채팅 대기실을 통해 입장해주세요.');
            } else {
              if (myInfo.userDetail?.id == null || myInfo.userDetail?.id === '') {
                openAlert('로그인 후 이용해주세요.');
              } else {
                window.open(
                  `/chatting-app/room/${contents.roomId}`, 
                  'Room', 
                  'width=1100px,height=640px,status=no,scrollbars=no,toolbar=no'
                );
              }
            }
          }}
        >
          [입장하기]
        </button>
      </div>
    );
  } else if (contents.systemMessageType === SystemMessageType.CLEAN_ROOM) {
    code = (<>{userDetail?.id === 'admin' ? '관리자' : userDetail?.id === roomDetil.owner ? '방장' : '매니저'} {userDetail?.nickname}님이 방을 청소하였습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.START_PROJECT) {
    code = (<>방장 {userDetail?.nickname}님이 새로운 프리미엄를 시작하였습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.JOIN_USER) {
    code = (<>{userDetail?.nickname}님이 채팅방에 참여하였습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.GIFT_BULLET) {
    if (roomDetil.id !== 'square') {
      if (contents.quantity == null) {
        return (<></>);
      }
      if (contents.quantity >= 100) {
        preparedCode = (
          <div style={{ textAlign: 'center' }}>
            <img src="/img/item/item_chip100.png" alt="a little cashs" style={{ height: '80px' }} />
          </div>
        );
      } else {
        preparedCode = (
          <div style={{ textAlign: 'center' }}>
            <img src="/img/item/item_chip10.png" alt="a little cashs" style={{ height: '80px' }} />
          </div>
        );
      }
    }
    code = (<>{userDetail?.nickname}님이 {contents.receiverName}님에게 보석 {contents.quantity}개를 선물하였습니다.</>);
  // } else if (contents.systemMessageType === SystemMessageType.PICK) {
  //   // Pick
  //   if (contents.pick == null) {
  //     return (<></>);
  //   }
  //   backgroundColor = '#9b00ce';
  //   const pick = contents.pick;
  //   preparedCode = (
  //     <>
  //       <div
  //         className="chatting-system-message"
  //         style={{
  //           backgroundColor,
  //         }}
  //       >
  //         {
  //           typeof contents.amount === 'number' && contents.amount > 0 ? (
  //             <>
  //               방장 {userDetail?.nickname}님이 <b>{
  //                 pick === 'PLAYER' ? '플레이어' :
  //                 pick === 'BANKER' ? '뱅커' :
  //                 '타이'
  //               }</b>에 {contents.amount.toLocaleString()}원을 배팅하였습니다.
  //             </>
  //           ) : (
  //             <>
  //               방장 {userDetail?.nickname}님이 <b>{
  //                 pick === 'PLAYER' ? '플레이어' :
  //                 pick === 'BANKER' ? '뱅커' :
  //                 '타이'
  //               }</b>를 선택하셨습니다.
  //             </>
  //           )
  //         }
  //       </div>
  //     </>
  //   );
  // } else if (contents.systemMessageType === SystemMessageType.PICK_RESULT) {
  //   backgroundColor = contents.result === 'PLAYER' ? '#2E83FF' :
  //     contents.result === 'BANKER' ? '#EC2024' :
  //     '#159252'

  //   preparedCode = (
  //     <>
  //       <div
  //         className="chatting-system-message"
  //         style={{
  //           backgroundColor,
  //         }}
  //       >
  //         {contents.round}회차 결과는 <b>{
  //           contents.result === 'PLAYER' ? '플레이어' :
  //           contents.result === 'BANKER' ? '뱅커' :
  //           '타이'
  //         }</b>입니다.
  //       </div>
  //     </>
  //   )
  //   code = (<></>);
  } else if (contents.systemMessageType === SystemMessageType.PICK) {
    // Pick
    if (contents.pick == null) {
      return (<></>);
    }
    backgroundColor = '#9b00ce';
    const [
      powerballOddEvenPick,
      powerballUnderOverPick,
      sumOddEvenPick,
      sumUnderOverPick,
      sumHighLowPick,
    ] = contents.pick.split('|');
    preparedCode = (
      <>
        <div className='chatting-system-message__pick'>
          <div>
            <div className={`chatting-system-message__pick__powerballOddEvenPick ${
              ((pick) => {
                switch (pick) {
                  case 'ODD':
                    return 'blue';
                  case 'EVEN':
                    return 'red';
                  default:
                    return '';
                }
              })(powerballOddEvenPick)
            }`}>
              {powerballOddEvenPick == 'ODD' ? '홀' : '짝'}
            </div>
            <div className={`chatting-system-message__pick__powerballUnderOverPick ${
              ((pick) => {
                switch (pick) {
                  case 'UNDER':
                    return 'blue';
                  case 'OVER':
                    return 'red';
                  default:
                    return '';
                }
              })(powerballUnderOverPick)
            }`}>
              {powerballUnderOverPick == 'UNDER' ? '언' : '오'}
            </div>
          </div>
          <div>
            <div className={`chatting-system-message__pick__sumOddEvenPick ${
              ((pick) => {
                switch (pick) {
                  case 'ODD':
                    return 'blue';
                  case 'EVEN':
                    return 'red';
                  default:
                    return '';
                }
              })(sumOddEvenPick)
            }`}>
              {sumOddEvenPick == 'ODD' ? '홀' : '짝'}
            </div>
            <div className={`chatting-system-message__pick__sumUnderOverPick ${
              ((pick) => {
                switch (pick) {
                  case 'UNDER':
                    return 'blue';
                  case 'OVER':
                    return 'red';
                  default:
                    return '';
                }
              })(sumUnderOverPick)
            }`}>
              {sumUnderOverPick == 'UNDER' ? '언' : '오'}
            </div>
          </div>
          <div className={`chatting-system-message__pick__sumHighLowPick-${
              ((pick) => {
                switch (pick) {
                  case 'LG':
                    return 'high';
                  case 'MD':
                    return 'middle';
                  case 'SM':
                    return 'low';
                  default:
                    return 'none';
                }
              })(sumHighLowPick)
            }`}>
            {sumHighLowPick == 'LG' ? '대' : sumHighLowPick == 'MD' ? '중' : '소'}
          </div>
        </div>
        {
          powerballOddEvenPick !== '' || powerballUnderOverPick !== ''
            ? (
              <div
                className="chatting-system-message"
                style={{
                  backgroundColor: (() => {
                    let color = '#9b00ce';

                    switch (powerballOddEvenPick) {
                      case 'ODD':
                        color = 'rgb(18, 101, 205)';
                        break;
                      case 'EVEN':
                        color = 'rgb(205, 18, 18)';
                    }

                    return color;
                  })(),
                }}
              >
                방장 {userDetail?.nickname}님이 <b>[파워볼] {[
                  powerballOddEvenPick ,powerballUnderOverPick
                ].filter((v) => v !== '').join(', ')}</b>을(를) 선택하셨습니다.
              </div>
            )
            : null
        }
        {
          sumOddEvenPick !== '' || sumUnderOverPick !== '' || sumHighLowPick !== ''
            ? (
              <div
                className="chatting-system-message"
                style={{
                  backgroundColor: (() => {
                    let color = '#9b00ce';

                    switch (sumOddEvenPick) {
                      case 'ODD':
                        color = 'rgb(18, 101, 205)';
                        break;
                      case 'EVEN':
                        color = 'rgb(205, 18, 18)';
                    }

                    return color;
                  })(),
                }}
              >
                방장 {userDetail?.nickname}님이 <b>[일반볼] {[
                  sumOddEvenPick, sumUnderOverPick, sumHighLowPick
                ].filter((v) => v !== '').join(', ')}</b>을(를) 선택하셨습니다.
              </div>
            )
            : null
        }
      </>
    );
  } else if (contents.systemMessageType === SystemMessageType.PICK_RESULT) {
    // Generated Result
    if (contents.fullRound == null) {
      return <></>;
    }

    const roundDate = contents.fullRound.split('|')[0].split('-');
    const pickText = contents.pick as string;
    const pickTextUnits = pickText.split('|');
    preparedCode = (
      <>
        <div
          className="chatting-system-message"
          style={{
            backgroundColor: (() => {
              let color = '#000000';

              switch (pickTextUnits[0]) {
                case 'ODD':
                  color = 'rgb(18, 101, 205)';
                  break;
                case 'EVEN':
                  color = 'rgb(205, 18, 18)';
              }

              return color;
            })(),
          }}
        >
          <span style={{ color: 'rgb(255, 243, 198)' }}>
            [{contents.fullRound.split('|')[1]}회]
          </span> 동행 파워볼 결과 
          <span style={{ color: 'rgb(255, 243, 198)' }}>
            [{pickTextUnits[0] == 'ODD'? '홀' : '짝'}][{pickTextUnits[1] == 'UNDER'? '언더' :'오버'}]
          </span>
        </div>
        <div
          className="chatting-system-message"
          style={{
            backgroundColor: (() => {
              let color = '#000000';

              switch (pickTextUnits[2]) {
                case 'ODD':
                  color = 'rgb(18, 101, 205)';
                  break;
                case 'EVEN':
                  color = 'rgb(205, 18, 18)';
              }

              return color;
            })(),
          }}
        >
          <span style={{ color: 'rgb(255, 243, 198)' }}>
            [{contents.fullRound.split('|')[1]}회]
          </span> 동행 일반볼 결과 
          <span style={{ color: 'rgb(255, 243, 198)' }}>
            [{pickTextUnits[2] == 'ODD'? '홀' : '짝'}][{pickTextUnits[3] == 'UNDER'? '언더' :'오버'}][{pickTextUnits[4] == 'LG' ? '대' : pickTextUnits[4] == 'MD' ? '중' :'소'}]
          </span>
        </div>
      </>
    )
    code = (<></>);
  } else if (contents.systemMessageType === SystemMessageType.DEFEAT_PROJECT) {
    code = (<>프리미엄에 실패하여 프리미엄 참가비용은 참가 회원들에게 반환됩니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.WIN_PROJECT) {
    code = (<>프리미엄 목표 금액에 달성하였습니다. 프리미엄가 종료되며, 참가 모금액은 방장에게 지급되었습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.CHANGE_GAME_TYPE) {
    code = (<>게임 타입이 '{contents.gameType}'로 변경되었습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.ROUND_RESULT) {
    if (contents.isWin === -1) {
      code = (<>해당 회차의 결과는 '타이' 이므로, 승패가 판정되지 않습니다. ({contents.record?.win}승 {contents.record?.defeat}패)</>);
    } else {
      code = (<>해당 회차에서 {contents.isWin === 1 ? '승리' : '패배'}하였습니다. ({contents.record?.win}승 {contents.record?.defeat}패)</>);
    }
  } else if (contents.systemMessageType === SystemMessageType.SNIPER_MESSAGE) {
    backgroundColor = '#fff';
    code = (
      <div>
        <b style={{ color: '#8cc346' }}>{contents.ownerName}</b>님이&nbsp;
        <b style={{ color: '#8cc346' }}>{contents.count}</b>연승을 달성하였습니다.&nbsp;
        <button
          style={{
            color: '#8cc346',
            padding: 0,
          }}
          onClick={() => {
            if (contents.isSecret) {
              openAlert('비밀방은 채팅 대기실을 통해 입장해주세요.');
            } else if (contents.isProject) {
              openAlert('프리미엄방은 채팅 대기실을 통해 입장해주세요.');
            } else {
              if (myInfo.userDetail?.id == null || myInfo.userDetail?.id === '') {
                openAlert('로그인 후 이용해주세요.');
              } else {
                window.open(
                  `/chatting-app/room/${contents.roomId}`, 
                  'Room', 
                  'width=1100px,height=640px,status=no,scrollbars=no,toolbar=no'
                );
              }
            }
          }}
        >
          [입장하기]
        </button>
      </div>
    );
  } else if (contents.systemMessageType === SystemMessageType.CHANGE_ROOM_TYPE) {
    code = (<>방 타입이 '{contents.isProject ? '프리미엄 방' : '일반 방'}'으로 변경되었습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.RECOMMEND_ROOM) {
    backgroundColor = '#606060';
    code = (<>{userDetail?.nickname}님이 좋아요를 눌렀습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.USE_CLEAR_HISTORY_ITEM) {
    code = (<>방장 {userDetail?.nickname}님이 전적을 초기화하였습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.KICK_USER) {
    code = (<>{contents.userName}님이 강제퇴장 당하였습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.FREEZE_USER) {
    const date = new Date(contents.expiredTime!);
    code = (<>{contents.userName}님이 {date.getHours()}시 {date.getMinutes()}분까지 벙어리 처리 되었습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.APPOINT_MANAGER) {
    code = (<>{contents.userName}님이 매니저로 임명되었습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.DISAPPOINT_MANAGER) {
    code = (<>{contents.userName}님이 매니저에서 해임되었습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.FREEZE_ALL) {
    code = (<>{contents.userId === 'admin' ? '관리자' : contents.userId === roomDetil.owner ? '방장' : '매니저'} {contents.userName}님이 채팅방을 얼렸습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.UNFREEZE_ALL) {
    code = (<>{contents.userId === 'admin' ? '관리자' : contents.userId === roomDetil.owner ? '방장' : '매니저'} {contents.userName}님이 채팅방 얼리기를 해제하였습니다.</>);
  } else if (contents.systemMessageType === SystemMessageType.RENAME_ROOM) {
    code = (<>방 제목이 '{contents.roomName}' (으)로 변경되었습니다.</>);
  }

  return (
    <>
      {preparedCode}
      {
        code !== (<></>) ? (
          <div
            className="chatting-system-message"
            style={{ backgroundColor, }}
          >
            {code}
          </div>
        ) : null
      }
    </>
  );
}

export default SystemMessage;